// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingCards_container__Lvt4t","loader":"LoadingCards_loader__WhOb_"};